import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Detects hard reload (Ctrl/Cmd+Shift+R) even when the page never gets the key event
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/promo-sw.js').catch(() => {
      /* ignore offline / unsupported */
    });
  });
}
